export default (optionText) => (record) => (record && record.id ? `${record.id}${record[optionText] ? ` (${optionText}:${record[optionText]})` : ''}` : '');
